"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchObjectListByProperty = exports.searchObjectByProperty = void 0;

// given an object, a property name, and a target value
// returns TRUE if the object posseses said property AND
// said property value matches target value. Otherwise FALSE
var searchObjectByProperty = function searchObjectByProperty(object, propertyName, targetValue) {
  if (object[propertyName] && object[propertyName] === targetValue) return true;else return false;
}; // given a list of objects, a property name, and a target value:
// searches through the list of objects and returns the index of the object
// which posseses the given property with the given value


exports.searchObjectByProperty = searchObjectByProperty;

var searchObjectListByProperty = function searchObjectListByProperty(objectList, propertyName, targetValue) {
  for (var i = 0; i < objectList.length; i++) {
    if (searchObjectByProperty(objectList[i], propertyName, targetValue)) return i;
  }

  return -1;
};

exports.searchObjectListByProperty = searchObjectListByProperty;